import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataTablesModule } from 'angular-datatables';

import { Ng2SmartTableModule } from 'ng2-smart-table';
import { ClientsRoutingModule } from './clients-routing.module';
import { ListClientComponent } from './list-client/list-client.component';
import { ClientDetailsComponent } from './client-detail/client-detail.component';

import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [ListClientComponent, ClientDetailsComponent],
  imports: [
    CommonModule,
    NgbModule,
    DataTablesModule,
    Ng2SmartTableModule,
    ReactiveFormsModule,
    ClientsRoutingModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ClientsModule { }
